//#region components/chip/chip_constants.js
var e = {
	100: "d-chip__label--xs",
	200: "d-chip__label--sm",
	300: "",
	xs: "d-chip__label--xs",
	sm: "d-chip__label--sm",
	md: ""
}, t = {
	100: "d-chip__close--xs",
	200: "d-chip__close--sm",
	300: "",
	xs: "d-chip__close--xs",
	sm: "d-chip__close--sm",
	md: ""
}, n = {
	100: "200",
	200: "200",
	300: "200",
	xs: "200",
	sm: "200",
	md: "200"
}, r = {
	CHIP_SIZE_MODIFIERS: e,
	CHIP_CLOSE_BUTTON_SIZE_MODIFIERS: t,
	CHIP_ICON_SIZES: n
};
//#endregion
export { t as CHIP_CLOSE_BUTTON_SIZE_MODIFIERS, n as CHIP_ICON_SIZES, e as CHIP_SIZE_MODIFIERS, r as default };

//# sourceMappingURL=chip-constants.js.map